import "./EllieTip.css";

export const EllieTip = (props) => {
  return (
    <div className="ellietip-box">
      <div className="ellietip-text">
        <p /*style={{ transform: `rotate(${props.angle}deg)` }}*/>{props.tip}</p>
        {/* <img src={props.image} style={{maxWidth: '353px', marginTop: '-10px'}} alt="Dinner Date"/> */}
      </div>
    </div>
  );
};

export default EllieTip;
